// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { clearUserCart } from "../../services/cartService";
// import { useDispatch, useSelector } from "react-redux";
// import { clearCart } from "../../redux/slices/cartSlice";
// import toast from "react-hot-toast";
// import { singleOrder } from "../../services/OrderService";
// import "../cart/Cart.css";
// import { userService } from "../../services/AuthenticationService";
// const OrderSuccess = (item) => {
//    const { state } = useLocation();
//   const dispatch = useDispatch();
//   const userId = useSelector((state) => state.auth.userId); 
//   const [order, setOrder] = useState();
//  const [loading, setLoading] = useState(true);
//    const { order_id } = state;
//      const [formData, setFormData] = useState({
//          name: "",
//          userName: "",
//          mobile: "",
//          email: "",
//          address1: "",
//          address2: "",
//          city: "",
//          state: "",
//          zip: "",
//          country: "",
//          phone: "",
        
//        });
//        console.log("formData",formData)
//       useEffect(() => {
//             if (userId) {
//               userService(userId)
//                 .then((response) => {
//                   setFormData(response);
//                 })
//                 .catch((error) => console.error("Error fetching profile:", error));
//             }
//           }, [userId]);
    
//   useEffect(() => {
//     const handleClearCart = async () => {
//       // if (!state) return;
//       if (!userId) {
//         dispatch(clearCart());
//         // toast.success("Cart cleared successfully!");
//       } else {
//         try {
//           const cartData = { createdUser: userId };
//           await clearUserCart(cartData);
//           dispatch(clearCart());
//           // toast.success("Cart cleared successfully!");
//         } catch (error) {
//           // toast.error("Failed to clear cart.");
//         }
//       }
//     };

//     handleClearCart();
//   }, [dispatch, userId]);
//  useEffect(() => {
//     if (userId) {
//     const fetchOrders = async () => {
//       try {
//         const order = await singleOrder(order_id);
//         setOrder(order);
//         console.log("orders",order)
//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchOrders();
//   }
//   }, [order_id]);
  


//   return (
 
//     <div className="container mt-5 text-white">
//       <h2>Order Summary</h2>
      
//       {/* <p><strong>Order ID:</strong> {order[0].guid}</p> */}
//       <h4 className="mt-4">Delivery address: </h4>
//       {/* <div>Manoj Varghese ,Axobis Technologies,4th floor ,Indo Archade,Cherooty road,kozhikode,Kerala,673032,phone:8734253618</div> */}
//       <p><strong>Name:</strong> {formData.name}</p>
//       <p><strong>Email:</strong> {formData.email}</p>
//       <p><strong>Phone:</strong> {formData.mobile}</p>
//       <p><strong>Address:</strong> {`${formData.address1} - ${formData.pin}`}</p>

//       <h4 className="mt-4">Items:</h4>
//       <table className="col-lg-12 text-white">
//                 <thead className="thead-primary bg-coffee mt-5 text-left">
//                   <tr className="text-left">
//                     <th>&nbsp;</th>
            
//                     <th>Product</th>
//                     <th>Price</th>
//                     <th>Quantity</th>
//                     <th>Total</th>
//                   </tr>
//                 </thead>
//                 <tbody className="">
//                   {/* {allCartItems.map((item) => ( */}
//                     <tr className="text-center border-bottom border-secondary" key={item?.prodGuId}>
                     
//                       <td className="image-prod p-2" >
//                       <Link className="nav-link" to={`/product/${item?.guid}`}>
//                             <img src="images/seracoffee-1.jpeg" alt={item.name} width={200} height={200} className="img-fluid image-product" />
//                           </Link>
                       
//                         </td>
//                       <td className="product-name text-left">
//                         <h3 className="h3-product">{item?.shortName}</h3>
//                         <p className="p-product p-color"></p>
//                       </td>
//                       <td className="price text-left"> <h5 className="p-product">{item?.retailRate}</h5></td>
//                       <td className="quantity">
//                       <div className="input-group col-md-6 d-flex mb-3">
//                       <span className="input-group-btn mr-2">
//                 {item?.quantity}2
//                 </span>
                
              
              
                 
//                 </div>
                       
//                       </td>
//                       <td className="total text-left"><h5 className="p-product"></h5></td>
//                       </tr>
//                   {/* ))} */}
//                 </tbody>
//               </table>
//               <div className="row justify-content-end mt-5">
//           <div className="col col-lg-3 col-md-6 cart-wrap">
//             <div className="cart-total mb-3 text-white">
            
              
    		
//             	<p className="d-flex total-price">
//     						<span>Total : </span>
//     						<span></span>
//     					</p>
//             </div>

//             {/* write a function for checkout only after login */}
//             {userId? (
//  <a href="/" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
//  Proceed to checkout
// </a>
//             ) : (
// <a href="/login" className="btn btn-primary p-3  rounded-0 text-center">login to complete your purchase</a> 
//             )}
           
//           </div>
//         </div>
//       {/* <ul>
//          {order[0].
// orderItemsList.map((item, idx) => (
//           <li key={idx}>
//             {item.shortName} x {item.quantity} = ₹{item.retailRate * item.quantity}
//           </li>
//         ))} 
//        </ul> */}

//       {/* <h5 className="mt-3">Subtotal: ₹{subtotal}</h5>
//        <h5>Discount: ₹{discount}</h5>
//        <h4>Total: ₹{total}</h4> */}
//      </div>
//   );
// };

// export default OrderSuccess;
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { clearUserCart } from "../../services/cartService";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../redux/slices/cartSlice";
import { singleOrder } from "../../services/OrderService";
import { userService } from "../../services/AuthenticationService";
import toast from "react-hot-toast";
import "../cart/Cart.css";

const OrderSuccess = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.userId);
  const { order_id } = state || {};

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    address1: "",
    pin: "",
  });

  useEffect(() => {
    if (userId) {
      userService(userId)
        .then((response) => setFormData(response))
        .catch((error) => console.error("Error fetching profile:", error));
    }
  }, [userId]);

  useEffect(() => {
    const clearCartHandler = async () => {
      if (!userId) {
        dispatch(clearCart());
      } else {
        try {
          await clearUserCart({ createdUser: userId });
          dispatch(clearCart());
        } catch (error) {
          console.error("Failed to clear cart:", error);
        }
      }
    };

    clearCartHandler();
  }, [dispatch, userId]);

  useEffect(() => {
    if (userId && order_id) {
      const fetchOrders = async () => {
        try {
          const order = await singleOrder(order_id);
          setOrder(order);
          console.log("orders", order);
      
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          setLoading(false);  // ✅ Now will be reached properly
        }
      };
      fetchOrders();
    }
  }, [order_id, userId]); // ✅ Correct dependencies
  
  if (loading) return<div className="container mt-5 mb-5 fs-3 text-white text-center">
  No Orders Found
</div>
  console.log("userId:", userId);
  console.log("state from location:", state);
  console.log("order_id:", order_id);
  

  return (
    <div className="container mt-5 text-white">
      <h2>Order Summary</h2>
      <p><strong>Order ID:</strong> {order_id}</p>

      <h4 className="mt-4">Delivery address:</h4>
      <p><strong>Name:</strong> {formData.name}</p>
      <p><strong>Email:</strong> {formData.email}</p>
      <p><strong>Phone:</strong> {formData.mobile}</p>
      <p><strong>Address:</strong> {`${formData.address1} - ${formData.pin}`}</p>

      <h4 className="mt-4">Items:</h4>
      <table className="col-lg-12 text-white">
        <thead className="thead-primary bg-coffee mt-5 text-left">
          <tr className="text-left">
            <th>&nbsp;</th>
            <th>Product</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
        {state.cartItems?.map((item) => (
            <tr key={item.prodGuId} className="text-center border-bottom border-secondary">
              <td className="image-prod p-2">
                <Link className="nav-link" to={`/product/${item.guid}`}>
                  {/* <img
                    src="images/seracoffee-1.jpeg"
                    alt={item.shortName}
                    width={200}
                    height={200}
                    className="img-fluid image-product"
                  /> */}
                       <img
  src={`https://inventory-api.exodusvacations.in/${item.thumbImage.trim().replace(/^wwwroot\//, "")}`}
  alt={item.name}
  width={100}
  height={80}
  className="img-fluid"
/>
                </Link>
              </td>
              <td className="product-name text-left">
                <h3 className="h3-product">{item.shortName}</h3>
              </td>
              <td className="price text-left">
                <h5 className="p-product">₹{item.retailRate}</h5>
              </td>
              <td className="quantity">
                <span className="input-group-btn mr-2">{item.quantity}</span>
              </td>
              <td className="total text-left">
                <h5 className="p-product">₹{item.retailRate * item.quantity}</h5>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="row justify-content-end mt-5">
        <div className="col col-lg-3 col-md-6 cart-wrap">
          <div className="cart-total mb-3 text-white">
            <p className="d-flex total-price">
              <span>Total :</span>
              <span>₹{state?.total}</span>
            </p>
          </div>

          {userId ? (
            <a href="/" className="btn btn-primary p-3 px-xl-4 py-xl-3 rounded-0">
              Back to Home
            </a>
          ) : (
            <a href="/login" className="btn btn-primary p-3 rounded-0 text-center">
              Login to view more orders
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
